import { Dispatch } from "redux";
import {
    setFraudReportReferenceData,
    setFraudReportReferenceDataLoading
} from "@redux/actions/fraud-report-actions";
import { getAssertionFraudReferenceDataRequest } from "@requests/reports/get-assertion-fraud-reference-data";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getFraudReportReferenceDataReduxRequest = (dispatch: Dispatch) => async () => {
    dispatch(setFraudReportReferenceDataLoading(true));
    const { data, error } = await getAssertionFraudReferenceDataRequest();
    if (data) {
        dispatch(setFraudReportReferenceData(data));
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.referenceData.error.title,
                resources.requests.referenceData.error.message
            );
        }
        dispatch(setFraudReportReferenceDataLoading(false));
    }
};